import React, { EffectCallback, ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';

import { Notification } from '../../types/entity.types';
import { RootState } from '../../types/state/root.types';
import { SystemState } from '../../types/state/system.types';

import { isToday, retrieveFromLocalStorage } from '../../utils/util';

import {
  requestViewAllNotifications,
  requestQueryNewNotifications,
  requestViewNewNotifications
} from '../../api/notification/notification.actions';

import Notifications from '../../components/common/notifications/Notifications';

type Props = {
  show: boolean;
};

const NotificationsContainer = ({ show }: Props): ReactElement => {
  const [todayNotifications, setTodayNotifications] = useState<Notification[]>([]);
  const [previousNotifications, setPreviousNotifications] = useState<Notification[]>([]);

  const { notifications } = useSelector(({ system }: RootState): SystemState => system);

  const dispatch: Dispatch = useDispatch();

  useEffect((): void => {
    const systemUserExternalReference: string = retrieveFromLocalStorage('user');
    // @ts-expect-error TODO: Fix after adding types to noticition actions
    dispatch(requestViewAllNotifications({ systemUserExternalReference }));
  }, [dispatch]);

  useEffect((): ReturnType<EffectCallback> => {
    const systemUserExternalReference: string = retrieveFromLocalStorage('user');

    const interval: NodeJS.Timeout = setInterval((): void => {
      if (notifications.length === 0) {
        // @ts-expect-error TODO: Fix after adding types to notification actions
        dispatch(requestViewAllNotifications({ systemUserExternalReference }));
      } else {
        const lastNotification: Notification = notifications[0] as Notification;
        const lastNotificationUUID: string = lastNotification.externalReference;

        dispatch(
          // @ts-expect-error TODO: Fix after adding types to notification actions
          requestQueryNewNotifications({
            systemUserExternalReference,
            lastNotificationUUID,
            onSuccess: (areNewNotifications: boolean): void => {
              if (areNewNotifications) {
                // @ts-expect-error TODO: Fix after adding types to notification actions
                dispatch(requestViewNewNotifications({ systemUserExternalReference, lastNotificationUUID }));
              }
            }
          })
        );
      }
    }, 60000);

    return (): void => clearInterval(interval);
  }, [dispatch, notifications]);

  useEffect((): void => {
    const todayNotifications: Notification[] = [];
    const previousNotifications: Notification[] = [];

    notifications.forEach((notification: Notification): void => {
      if (isToday(notification.date)) {
        todayNotifications.push(notification);
      } else {
        previousNotifications.push(notification);
      }
    });

    setTodayNotifications(todayNotifications);
    setPreviousNotifications(previousNotifications);
  }, [notifications]);

  return (
    <Notifications show={show} todayNotifications={todayNotifications} previousNotifications={previousNotifications} />
  );
};

export default NotificationsContainer;
